import { jsx } from "panel";
import { SegmentFilterDataTableEl } from "common/charts/misc/segment-filter-data-table";
import { Theme, TrackName as DataTableTrackName } from "common/components/data-table/types";
import { ActionsPopoverEl } from "common/widgets/actions-popover";
import { popoverBody } from "common/report/retention/visualization/popoverBody";
import { RetentionTrackingEvents as Events } from "common/report/retention/util/constants";
import { handlePopoverAction, trackPopover } from "common/report/retention/visualization/popover";
export function template() {
  const { popoverState } = this.state;
  const isSegmented = (this.state.query.groupBy || []).length > 0;
  const handlePopoverOpenCohortModal = (ev) => {
    const { type } = ev.detail;
    trackPopover({
      eventName: Events.PopoverClickCreateCohort,
      properties: {
        "cohort type": type
      },
      component: this,
      query: this.state.query,
      popover: popoverState.popover
    });
  };
  const handlePopoverCancelCohort = (ev) => {
    const { name, description, type } = ev.detail;
    trackPopover({
      eventName: Events.PopoverCancelCreateCohort,
      properties: {
        "cohort type": type,
        "cohort name": name,
        "cohort description": description
      },
      component: this,
      query: this.state.query,
      popover: popoverState.popover
    });
    this.closePopover();
  };
  return /* @__PURE__ */ jsx("div", {
    sel: ".retention-table"
  }, this.helpers.hasResults() ? /* @__PURE__ */ jsx("div", {
    sel: ".table-container"
  }, /* @__PURE__ */ jsx(SegmentFilterDataTableEl, {
    attrs: {
      elref: `dataTable`,
      "track-name": DataTableTrackName.RetentionCurve,
      collapsible: this.state.query ? !this.state.query.isNonIntervalized() : false,
      theme: Theme.Retention,
      "resizing-layout": this.attr(`resizing-layout`),
      "selected-cell": this.getSelectedCell()
    },
    on: {
      collapseChange: this.helpers.dataTable.handleCollapseChange,
      sortChange: this.helpers.dataTable.handleSortChange,
      cellClick: this.helpers.dataTable.handleCellClick,
      tableScroll: this.helpers.dataTable.closePopoverOnScroll
    }
  })) : /* @__PURE__ */ jsx("div", {
    sel: ".retention-no-data"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".retention-no-data-img"
  }), /* @__PURE__ */ jsx("div", {
    sel: ".retention-no-data-text"
  }, "We couldn't find any data for your query.")), (popoverState == null ? void 0 : popoverState.open) ? /* @__PURE__ */ jsx(ActionsPopoverEl, {
    attrs: {
      open: popoverState.open,
      title: popoverState.popover.getTitle(),
      subtitle: popoverState.popover.getSubtitle(),
      "button-options": popoverState.popover.getButtonOptions(),
      "is-segmented": isSegmented,
      "prevent-close-selectors": [`.data-cell`, `.mp-table-cell`],
      "project-id": this.attr(`project-id`)
    },
    props: {
      positionParent: popoverState.targetCell
    },
    on: {
      action: (ev) => handlePopoverAction({
        action: ev.detail.action,
        color: popoverState.bgColor,
        component: this,
        query: this.state.query,
        popover: popoverState.popover
      }),
      cancelCohort: handlePopoverCancelCohort,
      close: () => this.closePopover(),
      openCohortModal: handlePopoverOpenCohortModal
    }
  }, popoverBody({
    isAggregate: popoverState.popover.isAggregatedCell(),
    retainedCount: popoverState.popover.getRetainedCount(),
    dataGroupName: popoverState.popover.getDataGroupName(),
    dataGroupNamePlural: popoverState.popover.getDataGroupNamePlural(),
    retainedPercent: popoverState.retainedPercent,
    dropOffCount: popoverState.popover.getDropOffCount(),
    dropOffPercent: popoverState.dropOffPercent
  })) : null);
}
